module.exports = __webpack_public_path__ + "img/horizontal_3_6_pp1_5012.5ccaddf4.png";